import { render, staticRenderFns } from "./DetalleSale.vue?vue&type=template&id=658f87a2"
import script from "./DetalleSale.vue?vue&type=script&lang=js"
export * from "./DetalleSale.vue?vue&type=script&lang=js"
import style0 from "./DetalleSale.vue?vue&type=style&index=0&id=658f87a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports